import { inject } from 'aurelia-framework';
import { Redirect } from 'aurelia-router';

export class Capture {

  constructor() {
    this.home_url = window.home_url;
    if(window.whitelabel) {
      this.whitelabel = window.whitelabel;
      this.footer_html = window.footer_html;
    }
  }


  configureRouter(config, router) {
    this.router = router;
    config.title = window.whitelabel ? window.site_title : 'Magnfi Your Site | Video Testimonials at the Click of a Link';

    config.map([
      { route: [':key'], name: 'videoCapture', activationStrategy: "replace", moduleId: 'components/capture/videoCapture'},
      { route: ['remindme/:type/:key'], name: 'remindme', activationStrategy: "replace", moduleId: 'components/capture/remindme'},
      { route: ['decline/:type/:key'], name: 'decline', activationStrategy: "replace", moduleId: 'components/capture/decline'},
      { route: ['link/:key'], name: 'linkSubmissionStart', moduleId: 'components/capture/linkSubmissionStart', activationStrategy: "replace", settings: { captureType: 1 }},
      { route: ['brand/:key'], name: 'brandVideoStart', moduleId: 'components/capture/brandVideoStart', activationStrategy: "replace", settings: { captureType: 2 }},
      { route: ['case/:key'], name: 'caseStudyStart', moduleId: 'components/capture/caseStudyStart', activationStrategy: "replace", settings: { captureType: 4 }},
      { route: ['video/link/:id'], name: 'videoCapture', moduleId: 'components/capture/videoCapture', activationStrategy: "replace", settings: { captureType: 1 }},
      { route: ['video/testimonial-link/:id'], name: 'videoCapture', moduleId: 'components/capture/videoCapture', activationStrategy: "replace", settings: { captureType: 1,testimonialForm: 1 }},
      { route: ['video/brand/:id'], name: 'videoCapture', moduleId: 'components/capture/videoCapture', activationStrategy: "replace", settings: { captureType: 2 }},
      { route: ['video/expertTipVideo/:id/:link'], name: 'videoCapture', moduleId: 'components/capture/videoCapture',  settings: { auth:false,captureType: 2 }},
      { route: ['video/email/:id'], name: 'videoCapture', moduleId: 'components/capture/videoCapture', activationStrategy: "replace", settings: { captureType: 3 }},
      { route: ['video/message/:id'], name: 'videoCapture', moduleId: 'components/capture/videoCapture', activationStrategy: "replace", settings: { captureType: 5 }},
      { route: ['video/case/:key'], name: 'videoCapture', moduleId: 'components/capture/videoCapture', activationStrategy: "replace", settings: { captureType: 4 }},
      { route: ['public/:key'], name: 'publicVideos', moduleId: 'components/capture/publicVideos' },
      { route: ['thankyou'], name: 'thankyou', moduleId: 'components/capture/thankyou' },
      { route: ['error'], name: 'error', moduleId: 'components/capture/error' },
      { route: ['termsOfService'], name: 'terms', moduleId: 'components/capture/termsOfService', settings: { auth: true, wladmin: true } },
      { route: ['policy'], name: 'policy', moduleId: 'components/capture/policy', settings: { auth: true, wladmin: true } },
      { route: ['unsupported'], name: 'unsupported', moduleId: 'components/capture/unsupported' }




    ]);

    config.mapUnknownRoutes({ redirect: '#/capture/unsupported' });

  }




}



